var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
		'rounded-lg',
		_vm.disableText ? 'py-3' : 'py-4',
		_vm.disableText ? 'px-5' : 'px-3',
		'float-inherit',
		'text-white',
		_vm.buttonClass,
		'hover:bg-blue-700',
		'focus:outline-none',
		'text-sm',
		'font-semibold',
		'max-h-50',
		{ 'opacity-50 cursor-not-allowed': _vm.disabled },
		{ 'flex items-center': _vm.iconBefore || _vm.iconAfter },
		{ 'justify-center': !_vm.iconBefore && !_vm.iconAfter },
	],attrs:{"disabled":_vm.disabled,"icon":_vm.icon},on:{"click":_vm.handleClick}},[(_vm.iconBefore)?_c('span',{class:{ 'mr-2': !_vm.disableText }},[_c('i',{class:_vm.iconBefore})]):_vm._e(),_c('span',{class:{ 'ml-2': !_vm.disableText }},[_vm._t("iconBeforeImg")],2),(!_vm.disableText)?_c('span',{class:{ 'ml-2': !_vm.disableText }},[_vm._v(_vm._s(_vm.buttonText))]):_vm._e(),_c('span',{class:{ 'ml-2': !_vm.disableText }},[_vm._t("iconAfterImg")],2),(_vm.iconAfter)?_c('span',{class:{ 'mr-2': !_vm.disableText }},[_c('i',{class:_vm.iconAfter})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }